import request from '@/request/request'

export function listPatrolHistory(query) {
    return request({
        url: '/api/equipment-server/patrolInspection/history',
        method: 'get',
        params: query
    })
}

// 分页拉取全部巡更记录（后端 pageSize 上限 1000，内部自动翻页合并）
// query 不传 pageNum/pageSize，函数内部按 1000/页翻页，返回 { rows, total }
export function listAllPatrolHistory(query) {
    const pageSize = 1000;
    const base = Object.assign({}, query || {});
    const fetchPage = (pageNum) =>
        listPatrolHistory(Object.assign({}, base, { pageNum, pageSize }));
    return fetchPage(1).then((first) => {
        const rows = (first.rows || []).slice();
        const total = first.total || 0;
        const pages = Math.ceil(total / pageSize);
        if (pages <= 1) return { rows, total };
        const reqs = [];
        for (let p = 2; p <= pages; p++) reqs.push(fetchPage(p));
        return Promise.all(reqs).then((rest) => {
            rest.forEach((r) => rows.push.apply(rows, r.rows || []));
            return { rows, total };
        });
    });
}

export function getPersonMap() {
    return request({
        url: '/api/equipment-server/patrolInspection/personMap',
        method: 'get'
    })
}

export function getPlanMap() {
    return request({
        url: '/api/equipment-server/patrolInspection/planMap',
        method: 'get'
    })
}

// ===== 巡更计划 =====

export function listPatrolPlan(query) {
    return request({
        url: '/api/equipment-server/patrolInspection/plan/list',
        method: 'get',
        params: query
    })
}

export function getPatrolPlan(id) {
    return request({
        url: '/api/equipment-server/patrolInspection/plan/' + id,
        method: 'get'
    })
}

export function addPatrolPlan(data) {
    return request({
        url: '/api/equipment-server/patrolInspection/plan',
        method: 'post',
        data: data
    })
}

export function delPatrolPlan(ids) {
    return request({
        url: '/api/equipment-server/patrolInspection/plan/delete/' + ids,
        method: 'post'
    })
}

// ===== 巡更路线 =====

export function listPatrolRoute(query) {
    return request({
        url: '/api/equipment-server/patrolInspection/route/list',
        method: 'get',
        params: query
    })
}
